module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    staticClass: "account"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Find account')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/User-1.png")
    }
  }), _vm._v(" "), _c('p', {
    class: {
      'zh': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Enter username')))]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isE
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isE
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/User.png")
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.user
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "focus": function($event) {
        _vm.check4()
      },
      "blur": function($event) {
        _vm.check4()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "next",
    on: {
      "click": function($event) {
        _vm.check1(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.udHcp),
      expression: "udHcp"
    }],
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.udHcp),
      expression: "!udHcp"
    }],
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB),
      expression: "isB"
    }],
    staticClass: "verify"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Enter veri')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/Verfication Code.png")
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isZh),
      expression: "!isZh"
    }]
  }, [_vm._v(_vm._s(_vm.$t('VcodeTip1'))), _c('span', {
    staticClass: "tryAgain",
    class: {
      'disAble': _vm.tryAgain
    },
    on: {
      "click": _vm.sendSeccode1
    }
  }, [_vm._v(_vm._s(_vm.$t('VcodeTip2')))]), _vm._v(_vm._s(_vm.$t('VcodeTip3')) + "\n      "), _c('span', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }]
  }, [_vm._v(_vm._s(_vm.$t('VcodeTip1'))), _c('span', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(_vm._s(_vm.$t('VcodeTip2')) + "\n      "), _c('span', {
    staticClass: "tryAgain",
    class: {
      'disAble': _vm.tryAgain
    },
    on: {
      "click": _vm.sendSeccode1
    }
  }, [_vm._v(_vm._s(_vm.$t('VcodeTip3')))])]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor icon-spe2",
    class: {
      'in': _vm.isE
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Vcode),
      expression: "Vcode"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.veri
    },
    domProps: {
      "value": (_vm.Vcode)
    },
    on: {
      "focus": function($event) {
        _vm.check4()
      },
      "blur": function($event) {
        _vm.check4()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Vcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "next",
    on: {
      "click": function($event) {
        _vm.check2(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.check1(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isC),
      expression: "isC"
    }],
    staticClass: "create"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Create new')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/New password.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Create new notice')))]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isE
    }
  }, [_c('div', {
    class: {
      'in1': _vm.isE
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Password.png")
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isF),
      expression: "!isF"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": _vm.newpass,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "focus": function($event) {
        _vm.check4()
      },
      "blur": function($event) {
        _vm.check4()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isF),
      expression: "isF"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.newpass,
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "focus": function($event) {
        _vm.check4()
      },
      "blur": function($event) {
        _vm.check4()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.isF ? 'hide' : 'nohide'],
    attrs: {
      "id": "type"
    },
    on: {
      "click": _vm.choose
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "next",
    on: {
      "click": function($event) {
        _vm.check3()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.check2(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "completed"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Completed')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/Completed.png")
    }
  }), _vm._v(" "), _c('p', {
    class: {
      'zh': _vm.styleChange
    }
  }, [_vm._v(_vm._s(_vm.$t('Created')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.udHcp),
      expression: "udHcp"
    }],
    staticClass: "sign",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Login Now')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.udHcp),
      expression: "!udHcp"
    }],
    staticClass: "sign",
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Login Now')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b0d1158"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/updatePassword.vue
// module id = 1442
// module chunks = 7